import React, {useEffect, useState, useCallback} from 'react';
import t from 'babel-plugin-yate/macro';
import script from '../../lib/script';
import Icon from '../../components/Icons';
import {Text} from '../../components/uiElem';
import {startAdobe} from './sdkAdobe';

let registerCleanupListener = () => {};
let changePreviewHandler = null;

export function DocPreview({onSuccess}) {
  const divId = 'adobe-dc-view';
  const adobeJs = 'https://documentservices.adobe.com/view-sdk/viewer.js';
  const [selectedDoc, setSelectedDoc] = useState(null);

  // data Object ({ url, fileName })
  changePreviewHandler = useCallback(data => {
    setSelectedDoc(data);
  }, []);

  useEffect(() => {
    if (!selectedDoc) {
      return;
    }

    const {url, fileName} = selectedDoc;

    (async function initPdf() {
      try {
        await script('adobe-js', adobeJs);
      } catch (e) {
        console.log('adobe-js', e);
      }

      registerCleanupListener = startAdobe({divId, url, fileName});
      onSuccess && onSuccess();
    })();

    return () => registerCleanupListener();
  }, [selectedDoc, onSuccess]);

  return (
    <div
      className="overflow-hidden relative border-b border-black"
      style={{height: '0px', paddingTop: '56.25%'}}>
      <div id={divId} className="absolute top-0 left-0 w-full h-full" />
    </div>
  );
}

export function DocRow({fileName, url, isDefault}) {
  useEffect(() => {
    if (isDefault) {
      changePreviewHandler({url, fileName});
    }
  }, [url, fileName, isDefault]);

  return (
    <div className="p-4 flex items-center border-b">
      <Text ui="venus">
        <div
          className="flex items-center"
          onClick={() => changePreviewHandler({url, fileName})}>
          <span className="text-red-icon">
            <Icon name="PDF" />
          </span>
          <span className="pl-3">{fileName}</span>
        </div>
      </Text>

      <div className="ml-auto">
        <Text ui="venus">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            download={fileName}>
            {t`Download`}
          </a>
        </Text>
      </div>
    </div>
  );
}
